import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles.css";

try {
  const cap = typeof window !== "undefined" ? window.Capacitor : null;
  if (cap?.isNativePlatform?.()) {
    document.documentElement.classList.add("capacitor-native");
    const StatusBar = cap.Plugins?.StatusBar;
    if (StatusBar) {
      Promise.resolve()
        .then(() => StatusBar.setOverlaysWebView?.({ overlay: false }))
        .then(() => StatusBar.setBackgroundColor?.({ color: "#f5f7fb" }))
        .then(() => StatusBar.setStyle?.({ style: "DARK" }))
        .catch(() => {});
    }
  }
} catch {
  // web / non-capacitor
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  React.createElement(React.StrictMode, null,
    React.createElement(App, null)
  )
);
